<template>
  <div class="detailPage">
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">立项编码：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.code">{{productDetailData.code}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">产品类别：</div>
        <div class="right">
          <span
            class="value"
            v-if="productDetailData.productType"
          >{{productDetailData.productType.title}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">默认型号：</div>
        <div class="right">
          <span
            class="value"
            v-if="productDetailData.defaultModel"
          >{{productDetailData.defaultModel}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">项目经理：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.manager">{{productDetailData.manager.name}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">Key类型：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.p2pType">{{productDetailData.p2pType.title}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">默认PID：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.defaultPid">{{productDetailData.defaultPid}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">Key物料编码：</div>
        <div class="right">
          <span
            class="value"
            v-if="productDetailData.p2pItemCode"
          >{{productDetailData.p2pItemCode}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">产测工具：</div>
        <div class="right">
          <span
            class="value"
            v-if="productDetailData.factoryTools"
          >{{productDetailData.factoryTools.name}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">导入SN/UUID：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.importSn">导入</span>
          <span class="noValue" v-else>不导入</span>
        </div>
      </li>
      <li>
        <div class="left">校验和：</div>
        <div class="right">
          <span class="value">{{ productDetailData.checkSum ? productDetailData.checkSum : "-" }}</span>
        </div>
      </li>
      <li>
        <div class="left">固件版本管理：</div>
        <div class="right">      
          <span class="value" v-if="productDetailData.hasFw">
            Flash固件
          </span>
          <span class="value" v-if="productDetailData.hasMcu">
            MCU单片机
          </span>
          <span class="value" v-if="productDetailData.hasWiFi">
            WiFi网卡
          </span>
          <span class="value" v-if="productDetailData.hasBt">
            Bluetooth蓝牙
          </span>          
          <span class="noValue" v-if="!productDetailData.hasFw && !productDetailData.hasMcu && !productDetailData.hasWiFi && !productDetailData.hasBt">不管理</span>
        </div>
      </li>
      <li>
        <div class="left">MAC提供方：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.macSupport">{{productDetailData.macSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">无线MAC：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.wlanSupport">{{productDetailData.wlanSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">有线MAC：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.ethSupport">{{productDetailData.ethSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">蓝牙MAC：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.btSupport">{{productDetailData.btSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">IMEI/CMEI/CTEI：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.imeiSupport">{{productDetailData.imeiSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">配件SN：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.attachSnSupport">{{productDetailData.attachSnSupport.title}}</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">电池支持：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.batterySupport">支持</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">AP/SetupCode：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.apPassword">系统生成</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">语音识别：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.voice">支持</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">ADAS：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.adas">支持</span>
          <span class="noValue" v-else>不支持</span>
        </div>
      </li>
      <li>
        <div class="left">IQ二进制：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.hasIq">有</span>
          <span class="noValue" v-else>无</span>
        </div>
      </li>
      <li>
        <div class="left">最后修改人：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.lastUpdateUser">{{productDetailData.lastUpdateUser.name}}({{productDetailData.lastUpdateUser.employeeNum}})</span>
          <span class="noValue" v-else>-</span>
          <span class="value" v-if="productDetailData.lastUpdateDateTime"> 于 {{productDetailData.lastUpdateDateTime}}</span>
        </div>
      </li>
      <li style="width: 100%;">
        <div class="left">备注：</div>
        <div class="right">
          <span class="value" v-if="productDetailData.notes">{{productDetailData.notes}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
    </ul>
    <!-- <div class="operationBox">
      <el-button
        type="primary"
        size="mini"
        @click="$emit('editProductBtn', productDetailData)"
      >修改</el-button>
    </div> -->
    <div
      v-if="productDetailData.factoryTools && productDetailData.factoryTools.name == 'AoniFactoryTool-Tuya'"
    >
      <p class="title">配置信息</p>
      <ul class="ulBox clearFloat">
        <li class="blockLi">
          <div class="left">配置信息：</div>
          <div class="right">
            <el-input
              v-if="productDetailData.config"
              class="detailTextArea"
              type="textarea"
              :readonly="true"
              :autosize="{minRows: 1}"
              resize="none"
              :value="productDetailData.config"
            ></el-input>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div class="operationBox">
        <el-button icon="el-icon-edit" size="small" @click="editProductConfigBtn">修改</el-button>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      title="配置信息"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="600px"
    >
      <template slot="content">
        <el-form
          ref="editConfigForm"
          :model="editConfigForm"
          :rules="editConfigRules"
          :label-width="labelWidth"
        >
          <el-form-item label="配置信息" size="small" prop="config">
            <el-input
              type="textarea"
              :autosize="{minRows: 3, maxRows: 15}"
              v-model="editConfigForm.config"
              placeholder="配置信息"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/myDialog.vue";
import { apiProductDetail, apiProductUpdateConfig } from "@/api/productModel.js";
export default {
  props: {
    tabPaneValue: {
      type: String
    }
  },
  components: {
    myDialog
  },
  data() {
    return {
      productDetailData: {},
      editConfigForm: {},
      editConfigRules: {
        config: [
          { required: true, message: "配置信息不能为空！", trigger: "blur" }
        ]
      },
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 订单详情数据
    async getProductDetail(remove, callback) {
      if (remove != "noRemove") {
        this.productDetailData = {};
        this.$emit("productDetailLoaded", {});
      }
      const res = await apiProductDetail({
        id: this.tabPaneValue
      });
      // console.log(res);
      if (res.code == 0) {
        this.productDetailData = res.data;
        this.$emit("productDetailLoaded", res.data);
        if(callback) callback();
      }
    },
    // 修改产品配置信息按钮
    editProductConfigBtn() {
      this.$refs.myDialog.dialogVisible = true;
      this.editConfigForm = {
        id: this.tabPaneValue,
        config: this.productDetailData.config
      };
    },
    // 对话框确认按钮
    submitData(title) {
      this.$refs.editConfigForm.validate(valid => {
        if (valid) {
          if (title == "配置信息") {
            this.$confirm(
              `确定修改 ${this.productDetailData.name} 的配置信息吗?`,
              "配置信息",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            ).then(async () => {
              const res = await apiProductUpdateConfig({
                ...this.editConfigForm
              });
              // console.log(res);
              if (res.code == 0) {
                this.getProductDetail("noRemove");
                this.$refs.myDialog.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "修改成功"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 对话框关闭
    dialogClose() {
      this.$refs.editConfigForm.resetFields();
      this.editConfigForm = {};
    }
  }
};
</script>

<style lang="less" scoped>
</style>